import { __assign } from "tslib";
import React from 'react';
import { Box, Flex } from '@marvelapp/ui';
import { SpecsPanel, SpecsPanelProperty } from '@marvelapp/ui-internal';
export default function PanelAppearance(props) {
    var panelItems = getPanelItems(props);
    return (React.createElement(SpecsPanel, { title: "Appearance" },
        React.createElement(Flex, { flexWrap: "wrap", marginBottom: -3 }, panelItems.map(function (_a) {
            var label = _a.label, value = _a.value, itemProps = _a.itemProps;
            return (React.createElement(Box, __assign({ key: label, marginBottom: 20, width: 1 }, itemProps),
                React.createElement(SpecsPanelProperty, { isDisabled: true, label: label }, value)));
        }))));
}
function getPanelItems(_a) {
    var shapeStyle = _a.shapeStyle, symbol = _a.symbol;
    var panelItems = [];
    if (shapeStyle) {
        panelItems.push({
            label: 'Shape Style',
            value: shapeStyle,
        });
    }
    if (symbol) {
        panelItems.push({
            label: 'Symbol',
            value: symbol,
        });
    }
    return panelItems;
}
